export const formatMoney = (
  { amount, currencyCode = 'USD' },
  cents = false,
) => {
  if (isNaN(amount))
    return console.error('utils/format-money.js: No amount value passed.');

  if (cents) amount = amount / 100;

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return formatter.format(amount);
};
